import * as _ from "lodash";
import React, { useState } from "react";
import * as ReactModal from "react-modal";
// import { searchAssetBySerialNumber } from "../../../Middleware/assetChangeRequest";
import * as Models from "../../../Models";
import { Link } from "react-router-dom";
import { searchAssetBySerialNumber } from "../../../Api/azure";
import { toast } from "react-toastify";

interface SearchAssetBySerialNumberModalProps {
    open: number;
    handleOpenModal: (openState: number) => void;
    onClose: () => void;
}

export default function SearchAssetBySerialNumberModal(
    props: SearchAssetBySerialNumberModalProps
) {
    const [modalOpen, setModalOpen] = useState<number>(props.open);
    const [serialNumber, setSerialNumber] = useState<string>("");
    const {
        data: assetData,
        refetch,
        isFetching,
    } = searchAssetBySerialNumber(serialNumber);

    async function doSearch(event: any) {
        event.stopPropagation();
        const result = await refetch();
        result.error && toast.error("error");
    }

    function handleSerialnumberChange(event: { target: { value: any } }) {
        setSerialNumber(event.target.value);
    }

    function isValid(): boolean {
        return serialNumber?.length > 1;
    }

    function openNewChangeRequestModal(): void {
        props.handleOpenModal(2); //send parent component to open RequestNewAssetModal
    }

    function close(e: any) {
        e.stopPropagation();
        props.onClose();
    }

    if (modalOpen === 0) {
        return <></>;
    }

    const modalContent: JSX.Element = (
        <div className="container">
            {/* {!this.state.showRequestNewAssetModal ? (
                    <> */}
            <div className="row">
                <div className="col-lg-12">
                    <h2 className="Modal__header">Search assets</h2>
                    <span>
                        <p>
                            First enter the serial number of the asset you'd
                            like to add and press search.
                        </p>
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-group">
                        <label className="tiny">Serial number:</label>
                        <input
                            className="form-control"
                            value={serialNumber}
                            onChange={handleSerialnumberChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6 mt-4">
                    <button
                        className="btn btn-primary float-start"
                        onClick={(e) => doSearch(e)}
                        disabled={!isValid() || isFetching}
                    >
                        Search
                    </button>
                </div>
            </div>
            {assetData?.length > 0 && (
                /* Hiding this if there is no result */ <div className="row">
                    <div className="col-lg-12">
                        <span>
                            <hr className="hr hr-blurry" />
                        </span>
                    </div>
                </div>
            )}
            <div className="row">
                {assetData?.length > 0 && (
                    <div className="col-lg-12 table-responsive">
                        <p className="text-muted">
                            <mark>
                                These are the search results for the serial
                                number. Please review if the asset you wish to
                                create is already existing. If you find the
                                asset, click to open it and make modifications
                                through Edit functionality if needed
                            </mark>
                        </p>
                        <table className="table w-100 m-0">
                            <thead>
                                <tr>
                                    <th scope="col" className="pr-3 me-1">
                                        Product name
                                    </th>
                                    <th scope="col" className="pr-3 me-1">
                                        Product Type Description
                                    </th>
                                    <th scope="col" className="pr-3 me-1">
                                        Sn
                                    </th>
                                    <th scope="col" className="pr-3 me-1">
                                        Name
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {_.map(
                                    assetData.slice(
                                        0,
                                        assetData.length > 10
                                            ? 10
                                            : assetData.length
                                    ),
                                    (property: Models.SerialNumberDto) => {
                                        return (
                                            <tr>
                                                <td className="pr-3">
                                                    <Link
                                                        to={{
                                                            pathname: `/sites/location/${property.alternateId}`,
                                                        }}
                                                        target="_blank"
                                                    >
                                                        {property.productName}
                                                    </Link>
                                                </td>
                                                <td className="pr-3">
                                                    <Link
                                                        to={{
                                                            pathname: `/sites/location/${property.alternateId}`,
                                                        }}
                                                        target="_blank"
                                                    >
                                                        {
                                                            property.productTypeDescription
                                                        }
                                                    </Link>
                                                </td>
                                                <td className="pr-3">
                                                    <Link
                                                        to={{
                                                            pathname: `/sites/location/${property.alternateId}`,
                                                        }}
                                                        target="_blank"
                                                    >
                                                        {property.serialNumber}
                                                    </Link>
                                                </td>
                                                <td className="pr-3">
                                                    <Link
                                                        to={{
                                                            pathname: `/sites/location/${property.alternateId}`,
                                                        }}
                                                        target="_blank"
                                                    >
                                                        {property.name}
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    }
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <span>
                        <hr className="hr hr-blurry" />
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <p className="tiny text-muted">Add new asset here</p>
                    <div className="btn-group" role="group">
                        <button
                            className="btn btn-primary me-2"
                            onClick={(e) => openNewChangeRequestModal()}
                        >
                            Add new
                        </button>
                        <button
                            className="btn btn-secondary me-2"
                            onClick={(e) => close(e)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
            {/* </>
                ) : null} */}
        </div>
    );

    return (
        <ReactModal
            onRequestClose={() => props.onClose()}
            isOpen={modalOpen === 1}
            contentLabel="Modal"
            style={{ content: { maxHeight: "100%", overflowY: "auto" } }}
            defaultStyles={{}}
        >
            {modalContent}
        </ReactModal>
    );
}
